export default {
  fields: {
    list: [
      {
        fieldName: "ticker",
        displayName: "Identificador",
      },
    ],
    form: [
      {
        fieldName: "ticker",
        displayName: "Identificador",
      },
    ],
  },
};
